import { getAvatar } from '@/utils/helpers/profiles';
import css from './Avatar.module.css';

interface Profile {
  settings: {
    avatar?: string;
  };
}

interface AvatarProps {
  profile: Profile;
  onClick?: () => void;
  className?: string;
  alt?: string;
}

export function Avatar({ profile, onClick, className, alt = 'avatar' }: AvatarProps) {
  return (
    <span className={`${css.avatarImg} ${className || ''}`}>
      <img alt={alt} src={getAvatar(profile)} onClick={onClick} />
    </span>
  );
}

export function AvatarSmall({ profile, onClick, className, alt = 'avatar' }: AvatarProps) {
  return (
    <span className={`${css.avatarSmall} ${className || ''}`}>
      <img alt={alt} src={getAvatar(profile)} onClick={onClick} />
    </span>
  );
}

export function AvatarRound({ profile, onClick, className, alt = 'avatar' }: AvatarProps) {
  return (
    <span className={`${css.avatarRound} ${className || ''}`}>
      <img alt={alt} src={getAvatar(profile)} onClick={onClick} />
    </span>
  );
}
